module.exports = __webpack_public_path__ + "static/media/fc3.c5b769fc.png";